<ion-content class="template-channel-picker">
  <ion-list lines="none">
    <ion-item
      *ngFor="let c of sortedChannels; trackBy: trackByChannelId"
      [class.is-selected]="isDefault(c)"
      button
      detail="false"
      (click)="select(c)">
      <ion-label>{{ labelFor(c) | translate }}</ion-label>
      <ion-icon
        *ngIf="isDefault(c)"
        slot="end"
        name="checkmark"
        aria-label="default"
        class="default-check">
      </ion-icon>
    </ion-item>
  </ion-list>
</ion-content>
